var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.ActivityItem,{attrs:{"id":_vm.id,"activity-bar-id":_vm.id,"title":_vm.title,"tooltip":_vm.tooltip,"icon":_vm.icon,"progress-percentage":_setup.percentage,"progress-status":_setup.status},on:{"click":_setup.onUploadModal}})
}
var staticRenderFns = []

export { render, staticRenderFns }